import { render, staticRenderFns } from "./AddressRegion.vue?vue&type=template&id=6210cad8&"
import script from "./AddressRegion.vue?vue&type=script&lang=ts&"
export * from "./AddressRegion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports